//flicker.js

// Global valid parameters
var globalFlickerPath = false;
var globalFlickerCode;
var globalClockSpeed;
var clockSpeed;

var globalTimerSettings = [33, 50, 100, 150, 250]; 	// JS

const IMAGE_PATH = "/georgeFlicker/img";

const RENDER_NEW_FLICKER = true;

/**
 * Helper function converting a vw value to e.g. "20px"
 * @param {*} value vw as number
 */
function vwToPx(value) {
    const MAX_FLICKER_WIDTH = 500;
    const appWidth = Math.min(window.screen.width, MAX_FLICKER_WIDTH);
    return "" + (value / 100.0) * appWidth + "px";
}

// Create JavaScript Flicker
function javaScriptFlicker() {
    var timerLock = false;
    var timerRunning = true;
    var high = 0;
    var low = 1;
    var clkUp = 0;
    var clkDown = 1;

    clockSpeed = calculateMsFromClockSpeed();

    var halfVyteValue = new Array();
    halfVyteValue['0'] = [low, low, low, low];
    halfVyteValue['1'] = [low, low, low, high];
    halfVyteValue['2'] = [low, low, high, low];
    halfVyteValue['3'] = [low, low, high, high];
    halfVyteValue['4'] = [low, high, low, low];
    halfVyteValue['5'] = [low, high, low, high];
    halfVyteValue['6'] = [low, high, high, low];
    halfVyteValue['7'] = [low, high, high, high];
    halfVyteValue['8'] = [high, low, low, low];
    halfVyteValue['9'] = [high, low, low, high];
    halfVyteValue['A'] = [high, low, high, low];
    halfVyteValue['B'] = [high, low, high, high];
    halfVyteValue['C'] = [high, high, low, low];
    halfVyteValue['D'] = [high, high, low, high];
    halfVyteValue['E'] = [high, high, high, low];
    halfVyteValue['F'] = [high, high, high, high];

    var currentDigit = 0;
    var state = clkDown;

    function setFlicker(clock, nibble) {
        if (RENDER_NEW_FLICKER) {
            displayField("flicker_clk1", 1 - clock);
            if (nibble) {
                displayField("flicker_data0", 1 - halfVyteValue[nibble][3]);
                displayField("flicker_data1", 1 - halfVyteValue[nibble][2]);
                displayField("flicker_data2", 1 - halfVyteValue[nibble][1]);
                displayField("flicker_data3", 1 - halfVyteValue[nibble][0]);
            }
        } else {
            displayField("mini_clk1", clock);
            if (nibble) {
                displayField("mini_data0", halfVyteValue[nibble][3]);
                displayField("mini_data1", halfVyteValue[nibble][2]);
                displayField("mini_data2", halfVyteValue[nibble][1]);
                displayField("mini_data3", halfVyteValue[nibble][0]);
            }
        }
    }

    function displayField(field, visible) {
        var field = window.document.getElementById(field);
        if (field) {
            if (visible === 1) {
                field.style.visibility = 'visible';
            } else {
                field.style.visibility = 'hidden';
            }
        } else {
            clearTimeout(flickerTimer);
            timerRunning = false;
        }
    }

    var flickerTimer;

    this.clockTimer = function () {
        var thisC = this;

        this.nextTimer();
        if (timerRunning) {
            flickerTimer = window.setTimeout(function () {
                thisC.clockTimer();
            }, clockSpeed);
        }

    };

    this.nextTimer = function () {
        if (timerLock) {
            return;
        }

        timerLock = true;

        if (currentDigit >= datenarr.length) {
            state = clkUp;
            currentDigit = 0;
        }

        switch (state) {
            case clkUp:
                setFlicker(high, datenarr[currentDigit]);
                state = clkDown;
                break;
            case clkDown:
                setFlicker(low, datenarr[currentDigit]);
                state = clkUp;
                currentDigit++;
                break;
        }

        timerLock = false;
    };

    this.sortBytes = function () {
        var new_data = "0FF";
        for (var i = 0; i < globalFlickerCode.length; i = i + 2) {
            new_data = new_data + globalFlickerCode.substr(i + 1, 1) + globalFlickerCode.substr(i, 1);
        }
        return new_data;
    };

    var data = this.sortBytes();
    var datenarr = data.toUpperCase().split('');

    if (!RENDER_NEW_FLICKER) {
        var background = "<img id='bg_image' src='" + IMAGE_PATH + "/backgroundJS.gif' alt='' />";
        flickerWrite(background);

        flickerWrite("<div id='flicker_app_mini'>");
        var htmlContent = "<img class='flickersize' id='mini_clk1' src='" + IMAGE_PATH + "/clk1.gif' />"
            + "<img class='flickersize' id='mini_data0' src='" + IMAGE_PATH + "/data0.gif' />"
            + "<img class='flickersize' id='mini_data1' src='" + IMAGE_PATH + "/data1.gif' />"
            + "<img class='flickersize' id='mini_data2' src='" + IMAGE_PATH + "/data2.gif' />"
            + "<img class='flickersize' id='mini_data3' src='" + IMAGE_PATH + "/data3.gif' />";
        flickerWrite(htmlContent);
        flickerWrite("</div>");
    }

    var self = this;
    flickerTimer = setTimeout(function () {
        self.clockTimer();
    }, 500);
}

function endDiv() {
    flickerWrite('</div>');
}

/**
 * Draw a single arrow for the arrow section
 * 
 * @param {*} margin is either 0 or 1. So not a value, but a toggle.
 */
function drawFlickerArrow(scale, id, margin) {
    var arrow = sprintf(' <div \
        id=%s\
        style="\
            width: 0;\
	        height: 0;\
            border-left: %s solid transparent;\
            border-right: %s solid transparent;\
            border-top: %s solid white;\
            margin-left:%s;\
            "></div>', id, vwToPx(scale * 5.0), vwToPx(scale * 5.0), vwToPx(scale * 6.0), vwToPx(margin * scale * 50.0));
    flickerWrite(arrow);
}

/**
 * Draw arrow section
 */
function drawFlickerArrows(scale) {
    flickerWrite(sprintf('<div style="\
            margin: 0px;\
            padding: 0px;\
            width:%s; \
            display:flex;\
            flex-direction:row;\
            align-items:center;\
            justify-content:center;\
            ">', vwToPx(100)));

    drawFlickerArrow(scale, "flicker_arrow_left", 0);
    drawFlickerArrow(scale, "flicker_arrow_right", 1);
    endDiv();
}

/**
 * Draw a single bar of flicker code
 * 
 * @param {*} scale 
 * @param {*} id 
 * @param {*} margin is either 0 or 1. So not a value, but a toggle.
 */
function drawFlickerBar(scale, id, margin) {
    var bar = sprintf('<div \
        id=%s\
        style="\
            width:%s;\
            height:%s;\
            margin-left:%s;\
            background:white;"></div>', id, vwToPx(scale * 10.0), vwToPx(scale * 30.0), vwToPx(scale * margin * 5.0));

    flickerWrite(bar);
}

/**
 * Draw bars section
 */
function drawFlickerBars(scale) {
    var div = sprintf('<div style="\
            width:%s; \
            background: black;\
            padding-top:%s;\
            padding-bottom:%s;\
            display:flex;\
            flex-direction:row;\
            align-items:center;\
            justify-content:center;\
            ">)', vwToPx(100), vwToPx(scale * 4.0), vwToPx(scale * 8.0));
    flickerWrite(div);

    drawFlickerBar(scale, "flicker_clk1", 0);
    drawFlickerBar(scale, "flicker_data0", 1);
    drawFlickerBar(scale, "flicker_data1", 1);
    drawFlickerBar(scale, "flicker_data2", 1);
    drawFlickerBar(scale, "flicker_data3", 1);

    endDiv();
}

/**
 * New flicker drawing code
 */
function drawFlicker(scale) {
    flickerWrite(sprintf('\
        <div id="flicker_root" \
            style="\
                display:flex;\
                width:%s;\
                flex-direction:column;\
                align-items:center;\
                background:black;\
                justify-content: flex-start;\
        ">', vwToPx(100)));

    drawFlickerArrows(scale);
    drawFlickerBars(scale);

    endDiv();
}

var flickerScale = 1.2;

var flickerStr = "";

export function showFlickerCode(startCodeValue, flickerCode, clockSpeed) {
    flickerStr = "";
    globalFlickerCode = flickerCode;

    // console.log("Flicker :: " + globalFlickerCode + "/ Speed : " + clockSpeed);

    globalClockSpeed = clockSpeed;

    if (globalClockSpeed < 1) {
        globalClockSpeed = 1;
    }

    if (globalClockSpeed > 5) {
        globalClockSpeed = 5;
    }

    var clockSpeedCookie = getFlickerCookieValue('clockSpeed');
    if (clockSpeedCookie != null) {
        // console.log("Flicker :: Found Cookied with Speed : " + clockSpeedCookie);
        globalClockSpeed = clockSpeedCookie;
    }

    if (RENDER_NEW_FLICKER) {
        new javaScriptFlicker();
        flickerWrite("<div>");
        drawFlicker(flickerScale);
        endDiv();
    } else {
        flickerWrite("<div id='flicker_mini'>");
        new javaScriptFlicker();
        endDiv();
    }

    loadFlickerCookie();
    return flickerStr;
}

function flickerWrite(str) {
    flickerStr += str;
}

function getFlickerWidth() {
    var flickerObjects = ['flicker_mini'];
    var width = 0;
    for (var i = 0; i < flickerObjects.length; i++) {
        var flickerObject = document.getElementById(flickerObjects[i]);
        flickerObject ? width = flickerObject.offsetWidth : null;
        if (width > 0) {
            return width;
        }
    }
    return width;
}

function clamp(value, min, max) {
    return Math.min(Math.max(min, value), max);
}

export function resizeFlicker(a) {
    if (RENDER_NEW_FLICKER) {
        var flicker = document.getElementById("flicker_root");
        if (flicker) {
            flickerScale = clamp(flickerScale + a, 0.5, 1.5);
            // console.log(flickerScale);

            // Throw away old flicker
            var container = flicker.parentNode;
            container.removeChild(flicker);

            // Draw new flicker
            flickerStr = "";
            drawFlicker(flickerScale);
            container.innerHTML = flickerStr;
        }
    } else {
        a *= 5;
        var width = getFlickerWidth();
        if (width < 50 && a < 0) {
            return;
        }
        if (width < 224) {
            width = 224;
        }
        if (width > 600) {
            width = 600;
        }

        var newWidth = Math.round(width * (1 + a / 10));
        var flickerMiniObject = document.getElementById('flicker_mini');
        if (flickerMiniObject) {
            var height = Math.round(newWidth * (22 / 65));
            var appwidth = Math.round(newWidth * (45 / 65));
            var appheight = Math.round(appwidth * (22 / 65));
            resizeFlickerWH(newWidth, height, appwidth, appheight, 'px');
        }
    }
}

function resizeFlickerWH(w, h, aw, ah, unit) {
    setFlickerCookieValue('width', w, true);
    var proof = Math.round(w - (w / 55 * 54));
    var frameSizes = ['flicker_mini', 'bg_image'];
    for (var i = 0; i < frameSizes.length; i++) {
        var elem = document.getElementById(frameSizes[i]);
        if (elem) {
            elem.style.height = (h * 1.39) + unit;
            elem.style.width = w + unit;
        }
    }

    // Resize black bars covering flicker
    var appSizes = ['mini_clk1', 'mini_clk2', 'mini_data0', 'mini_data1', 'mini_data2', 'mini_data3'];
    for (var i = 0; i < appSizes.length; i++) {
        var elem = document.getElementById(appSizes[i]);
        if (elem) {
            elem.style.height = (ah * 1.39) + unit;
            elem.style.width = (aw * 1.15) + unit;
        }
    }

    // Resize container for bars
    var appMargin = document.getElementById('flicker_app_mini');
    if (appMargin) {
        appMargin.style.top = (((h - ah) / 2) + 8) + unit;
        appMargin.style.left = (((w - proof - aw) / 2) * 0.7) + unit;
    }
}

function loadFlickerCookie(width) {
    if (!width) {
        width = getFlickerCookieValue('width');
        if (width < 300 || width == null) {
            resizeFlicker(1);
        }
    }
    var flickerMiniObject = document.getElementById('flicker_mini');
    if (flickerMiniObject && width) {
        var miniHeight = Math.round(width * (22 / 65));
        var appMiniWidth = Math.round(width * (45 / 65));
        var appMiniHeight = Math.round(appMiniWidth * (22 / 65));
        resizeFlickerWH(width, miniHeight, appMiniWidth, appMiniHeight, 'px');
    }
}

export function flickerSpeedFaster() {
    var clSpeed = parseInt(globalClockSpeed);
    clSpeed -= 1;
    globalClockSpeed = clSpeed;
    if (globalClockSpeed < 1) {
        globalClockSpeed = 1;
    }
    setFlickerCookieValue('clockSpeed', globalClockSpeed, true);
    clockSpeed = calculateMsFromClockSpeed();
}

export function flickerSpeedSlower() {
    var clSpeed = parseInt(globalClockSpeed);
    clSpeed += 1;
    globalClockSpeed = clSpeed;
    if (globalClockSpeed > 5) {
        globalClockSpeed = 5;
    }
    setFlickerCookieValue('clockSpeed', globalClockSpeed, true);
    clockSpeed = calculateMsFromClockSpeed();
}

function calculateMsFromClockSpeed() {
    return globalTimerSettings[globalClockSpeed - 1];
}

function getFlickerCookieValue(key) {
    var results = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    if (results)
        return (unescape(results[2]));
    else
        return null;
}

function setFlickerCookieValue(key, value, holdCookie) {
    var cookieString = key + "=" + escape(value);
    if (holdCookie) {
        var expires = new Date();
        expires = new Date(expires.getTime() + 1000 * 60 * 60 * 24 * 365);
        cookieString += "; expires=" + expires.toGMTString();
    }
    document.cookie = cookieString;
}

//
// flickerCalc.js
//

// Change the committed parameter to ASCIIHexFormat
function getASCIIHexFormatForSecOPTICCharacterSet(elements) {
    var acharCode;
    var asciiElements = "";

    for (var i = 0; i < elements.length; ++i) {
        acharCode = elements.charCodeAt(i);

        if (acharCode == 8364) { 	// Euro-symbol
            acharCode = 164;
        }
        if (acharCode == 286) {
            acharCode = 208;
        }
        if (acharCode == 287) {
            acharCode = 241;
        }
        if (acharCode == 304) {
            acharCode = 221;
        }
        if (acharCode == 305) {
            acharCode = 253;
        }
        if (acharCode == 350) {
            acharCode = 222;
        }
        if (acharCode == 351) {
            acharCode = 254;
        }

        if (acharCode > 0xff) {
            alert("Error, wrong char");
        }

        asciiElements += sprintf("%02X", acharCode);
    }
    return asciiElements;
}

// Change the committed parameter to ASCIIHexFormat
function getASCIIHexFormatForZKACharacterSet(elements) {
    var acharCode;
    var asciiElements = "";

    for (var i = 0; i < elements.length; ++i) {
        acharCode = elements.charCodeAt(i);

        if (acharCode == 8364) { 	// Euro-symbol
            acharCode = 36;
        }
        if (acharCode == 196) {		// �
            acharCode = 91;
        }
        if (acharCode == 214) {		// �
            acharCode = 92;
        }
        if (acharCode == 220) {		// �
            acharCode = 93;
        }
        if (acharCode == 163) {		// Pound-symbol
            acharCode = 94;
        }
        if (acharCode == 228) {		// �
            acharCode = 123;
        }
        if (acharCode == 246) {		// �
            acharCode = 124;
        }
        if (acharCode == 252) {		// �
            acharCode = 125;
        }
        if (acharCode == 223) {		// �
            acharCode = 126;
        }

        if (acharCode > 0xff) {
            alert("Error, wrong char");
        }

        asciiElements += sprintf("%02X", acharCode);
    }
    return asciiElements;
}

// Non ASCII elements (For example: A BCD element) become normalize.
function normalizeNonASCIIElements() {
    var result = arguments[0];

    if ((result.length % 2) == 1) {
        result = result + 'F';
    }
    return result;
}

// Check if the comittet parameter contains non digits
function containsNonDigits() {
    var cut = arguments[0];
    var i;

    for (i = 0; i < cut.length; ++i) {
        if (cut.charAt(i) < "0" || cut.charAt(i) > "9") {
            return true;
        }
    }
    return false;
}

// Returns the constructed LS byte
function getLS(controlByte, startCodeTyp, startLength) {
    var ls = sprintf("%b", startLength);

    for (var i = ls.length; i < 6; i++) {
        ls = "0" + ls;
    }
    ls = startCodeTyp + ls;
    ls = controlByte + ls;
    return ls;
}

// Returns the constructed LBDEX byte
function getLbdex(bdeTyp, bdeLength) {
    var ldbex = sprintf("%b", bdeLength);

    for (var i = ldbex.length; i < 6; i++) {
        ldbex = "0" + ldbex;
    }
    ldbex = bdeTyp + ldbex;
    ldbex = "0" + ldbex;
    return ldbex;
}

// Returns the decimal value from a half byte
function getHalfByteDezValue(halfByte) {
    var dezValue;

    switch (halfByte) {
        case "0000":
            dezValue = 0;
            break;
        case "0001":
            dezValue = 1;
            break;
        case "0010":
            dezValue = 2;
            break;
        case "0011":
            dezValue = 3;
            break;
        case "0100":
            dezValue = 4;
            break;
        case "0101":
            dezValue = 5;
            break;
        case "0110":
            dezValue = 6;
            break;
        case "0111":
            dezValue = 7;
            break;
        case "1000":
            dezValue = 8;
            break;
        case "1001":
            dezValue = 9;
            break;
        case "1010":
            dezValue = 10;
            break;
        case "1011":
            dezValue = 11;
            break;
        case "1100":
            dezValue = 12;
            break;
        case "1101":
            dezValue = 13;
            break;
        case "1110":
            dezValue = 14;
            break;
        case "1111":
            dezValue = 15;
            break;
    }
    return dezValue;
}

//Gather the informations, they are necessary to start the xor calculation for specification Stuzza (HHD 1.4)
function getXorDataV14Stuzza(startLength, startCode, bde1Length, bde1Code, bde2Length, bde2Code, length, bde3Length, bde3Code, bde4Length, bde4Code, bde5Length, bde5Code, bde6Length, bde6Code, startCodeTyp, bde1Typ, bde2Typ, bde3Typ, bde4Typ, bde5Typ, bde6Typ) {
    var xorData;
    var ls;
    var lsLeftHalfbyte;
    var lsRightHalfbyte;
    var controlByte;
    var lbdex;
    var lbdexLeftHalfbyte;
    var lbdexRightHalfbyte;

    if (startCodeTyp == 1) {																// ASCII values
        ls = getLS(1, 1, startLength);
    } else {																				// Non ASCII values
        ls = getLS(1, 0, startLength);
    }
    lsLeftHalfbyte = getHalfByteDezValue(ls.substr(0, 4));
    lsRightHalfbyte = getHalfByteDezValue(ls.substr(4, 8));
    xorData = sprintf("%X%X", lsLeftHalfbyte, lsRightHalfbyte);								// xor_data: set LS;
    controlByte = 0x0;																		// xor_data: set controlByte (HHD 1.4)
    controlByte = "8" + controlByte;														// xor_data: set controlByte (other Control Byte)
    xorData += controlByte;
    secondControlByte = "0" + "9";															// ControlByte for Austria, Version 0001, no other controlByte
    xorData += secondControlByte;
    xorData += startCode;																	// xor_data: set Start-Code

    if (bde1Length > 0) {
        length += 1 + bde1Length;															// LC=LC+LBDE1+(BDE1-length)
        if (bde1Typ == 1) {																	// ASCII values
            lbdex = getLbdex(1, bde1Length);
        } else {																			// Non ASCII values
            lbdex = getLbdex(0, bde1Length);
        }
        lbdexLeftHalfbyte = getHalfByteDezValue(lbdex.substr(0, 4));
        lbdexRightHalfbyte = getHalfByteDezValue(lbdex.substr(4, 8));
        xorData += sprintf("%X%X", lbdexLeftHalfbyte, lbdexRightHalfbyte) + bde1Code;		// xor_data: LS; Start-Code; set LBDE1; set BDE1
    }

    if (bde2Length > 0) {
        length += 1 + bde2Length;															// LC=LC+LBDE2+BDE2-length)
        if (bde2Typ == 1) {																	// ASCII values
            lbdex = getLbdex(1, bde2Length);
        } else {																			// Non ASCII values
            lbdex = getLbdex(0, bde2Length);
        }
        lbdexLeftHalfbyte = getHalfByteDezValue(lbdex.substr(0, 4));
        lbdexRightHalfbyte = getHalfByteDezValue(lbdex.substr(4, 8));
        xorData += sprintf("%X%X", lbdexLeftHalfbyte, lbdexRightHalfbyte) + bde2Code;		// xor_data: LS; Start-Code; LBDE1; BDE1; set LBDE2; set BDE2
    }

    if (bde3Length > 0) {
        length += 1 + bde3Length;
        if (bde3Typ == 1) {																	// ASCII values
            lbdex = getLbdex(1, bde3Length);
        } else {																			// Non ASCII values
            lbdex = getLbdex(0, bde3Length);
        }
        lbdexLeftHalfbyte = getHalfByteDezValue(lbdex.substr(0, 4));
        lbdexRightHalfbyte = getHalfByteDezValue(lbdex.substr(4, 8));
        xorData += sprintf("%X%X", lbdexLeftHalfbyte, lbdexRightHalfbyte) + bde3Code;		// xor_data: LS; Start-Code; LBDE1; BDE1; LBDE2; BDE2; set LBDE3; set BDE3
    }

    if (bde4Length > 0) {
        length += 1 + bde4Length;
        if (bde4Typ == 1) {																	// ASCII values
            lbdex = getLbdex(1, bde4Length);
        } else {																			// Non ASCII values
            lbdex = getLbdex(0, bde4Length);
        }
        lbdexLeftHalfbyte = getHalfByteDezValue(lbdex.substr(0, 4));
        lbdexRightHalfbyte = getHalfByteDezValue(lbdex.substr(4, 8));
        xorData += sprintf("%X%X", lbdexLeftHalfbyte, lbdexRightHalfbyte) + bde4Code;
    }

    if (bde5Length > 0) {
        length += 1 + bde5Length;
        if (bde5Typ == 1) {																	// ASCII values
            lbdex = getLbdex(1, bde5Length);
        } else {																			// Non ASCII values
            lbdex = getLbdex(0, bde5Length);
        }
        lbdexLeftHalfbyte = getHalfByteDezValue(lbdex.substr(0, 4));
        lbdexRightHalfbyte = getHalfByteDezValue(lbdex.substr(4, 8));
        xorData += sprintf("%X%X", lbdexLeftHalfbyte, lbdexRightHalfbyte) + bde5Code;
    }

    if (bde6Length > 0) {
        length += 1 + bde6Length;
        if (bde6Typ == 1) {																	// ASCII values
            lbdex = getLbdex(1, bde6Length);
        } else {																			// Non ASCII values
            lbdex = getLbdex(0, bde6Length);
        }
        lbdexLeftHalfbyte = getHalfByteDezValue(lbdex.substr(0, 4));
        lbdexRightHalfbyte = getHalfByteDezValue(lbdex.substr(4, 8));
        xorData += sprintf("%X%X", lbdexLeftHalfbyte, lbdexRightHalfbyte) + bde6Code;
    }

    xorData = sprintf("%02X%s", length, xorData);
    return xorData;
}

// Create the Flicker-Code by specification Stuza (HHD 1.4)
function stuzzaHHD14Flicker(startCodeValue, bde1Value, bde2Value, bde3Value, bde4Value, bde5Value, bde6Value) {
    var startCode;		//Start-Code
    var startLength; 	//LS
    var bde1Code;		//BDE1
    var bde1Length;
    var bde2Code;		//BDE2
    var bde2Length;
    var bde3Code;		//BDE3
    var bde3Length;
    var bde4Code;		//BDE4
    var bde4Length;
    var bde5Code;		//BDE5
    var bde5Length;
    var bde6Code;		//BDE6
    var bde6Length;
    var length;			//LC
    var startCodeTyp, bde1Typ, bde2Typ, bde3Typ, bde4Typ, bde5Typ, bde6Typ;

    // Startcode
    if (startCodeValue == "") {
        alert("Please insert a Startcode!");
        return false;
    } else {
        if (containsNonDigits(startCodeValue) == true) {				// ASCII values
            alert("Please insert only numbers in the Startcode!");
            return false;
        } else if (containsNonDigits(startCodeValue) == false) {	// Non ASCII values
            startCode = normalizeNonASCIIElements(startCodeValue);
            startLength = startCode.length /= 2;
            startCodeTyp = 0;
        }
    }

    // BDE 1
    if (containsNonDigits(bde1Value) == true) {						// ASCII values
        bde1Length = bde1Value.length;
        bde1Code = getASCIIHexFormatForZKACharacterSet(bde1Value);
        bde1Typ = 1;
    } else if (containsNonDigits(bde1Value) == false) {				// Non ASCII values
        bde1Code = normalizeNonASCIIElements(bde1Value);
        bde1Length = bde1Code.length / 2;
        bde1Typ = 0;
    }

    // BDE 2
    if (containsNonDigits(bde2Value) == true) {						// ASCII values
        bde2Length = bde2Value.length;
        bde2Code = getASCIIHexFormatForZKACharacterSet(bde2Value);
        bde2Typ = 1;
    } else if (containsNonDigits(bde2Value) == false) {				// Non ASCII values
        bde2Code = normalizeNonASCIIElements(bde2Value);
        bde2Length = bde2Code.length / 2;
        bde2Typ = 0;
    }

    // BDE 3
    if (containsNonDigits(bde3Value) == true) {						// ASCII values
        bde3Length = bde3Value.length;
        bde3Code = getASCIIHexFormatForZKACharacterSet(bde3Value);
        bde3Typ = 1;
    } else if (containsNonDigits(bde3Value) == false) {				// Non ASCII values
        bde3Code = normalizeNonASCIIElements(bde3Value);
        bde3Length = bde3Code.length / 2;
        bde3Typ = 0;
    }

    // BDE 4
    if (containsNonDigits(bde4Value) == true) {						// ASCII values
        bde4Length = bde4Value.length;
        bde4Code = getASCIIHexFormatForZKACharacterSet(bde4Value);
        bde4Typ = 1;
    } else if (containsNonDigits(bde4Value) == false) {				// Non ASCII values
        bde4Code = normalizeNonASCIIElements(bde4Value);
        bde4Length = bde4Code.length / 2;
        bde4Typ = 0;
    }

    // BDE 5
    if (containsNonDigits(bde5Value) == true) {						// ASCII values
        bde5Length = bde5Value.length;
        bde5Code = getASCIIHexFormatForZKACharacterSet(bde5Value);
        bde5Typ = 1;
    } else if (containsNonDigits(bde5Value) == false) {				// Non ASCII values
        bde5Code = normalizeNonASCIIElements(bde5Value);
        bde5Length = bde5Code.length / 2;
        bde5Typ = 0;
    }

    // BDE 6
    if (containsNonDigits(bde6Value) == true) {						// ASCII values
        bde6Length = bde6Value.length;
        bde6Code = getASCIIHexFormatForZKACharacterSet(bde6Value);
        bde6Typ = 1;
    } else if (containsNonDigits(bde6Value) == false) {				// Non ASCII values
        bde6Code = normalizeNonASCIIElements(bde6Value);
        bde6Length = bde6Code.length / 2;
        bde6Typ = 0;
    }

    length = 1 + 1 + 1 + 1 + startLength;												// LC=LS+CB+two controlBytes+start_len
    controlByte = 0x0;																	// xor_data: set controlByte (HHD 1.4)
    controlByte = "8" + controlByte;													// xor_data: set controlByte (other Control Byte follow)
    secondControlByte = "0" + "9";														// ControlByte for Austria, Version 0001, no other controlByte

    // Luhn, Xor, Flickercode
    var luhn = luhnCalc(controlByte + secondControlByte + startCode + bde1Code + bde2Code + bde3Code + bde4Code + bde5Code + bde6Code);	// calculate luhn
    var xorData = getXorDataV14Stuzza(startLength, startCode, bde1Length, bde1Code, bde2Length, bde2Code, length, bde3Length, bde3Code, bde4Length, bde4Code, bde5Length, bde5Code, bde6Length, bde6Code, startCodeTyp, bde1Typ, bde2Typ, bde3Typ, bde4Typ, bde5Typ, bde6Typ);
    var xor = xorCalc(xorData);															// calculate xor
    var flickerCode = xorData + sprintf("%X%X", luhn, xor);								// Flickercode: LC; LS; Start-Code; LBDE1; BDE1; LBDE2; BDE2; LBDE3; BDE3; LBDE4; BDE4; LBDE5; BDE5; LBDE6; BDE6; set Luhn; set xor
    return flickerCode;
}

// Gather the informations, they are necessary to start the xor calculation for specification HHD 1.4
function getXorDataV14(startLength, startCode, bde1Length, bde1Code, bde2Length, bde2Code, length, bde3Length, bde3Code, startCodeTyp, bde1Typ, bde2Typ, bde3Typ) {
    var xorData;
    var ls;
    var lsLeftHalfbyte;
    var lsRightHalfbyte;
    var controlByte;
    var lbdex;
    var lbdexLeftHalfbyte;
    var lbdexRightHalfbyte;

    if (startCodeTyp == 1) {																// ASCII values
        ls = getLS(1, 1, startLength);
    } else {																				// Non ASCII values
        ls = getLS(1, 0, startLength);
    }
    lsLeftHalfbyte = getHalfByteDezValue(ls.substr(0, 4));
    lsRightHalfbyte = getHalfByteDezValue(ls.substr(4, 8));
    xorData = sprintf("%X%X", lsLeftHalfbyte, lsRightHalfbyte);								// xor_data: set LS;
    controlByte = 0x1;																		// xor_data: set controlByte (HHD 1.4)
    controlByte = "0" + controlByte;														// xor_data: set controlByte (no other Control Byte)
    xorData += controlByte;
    xorData += startCode;																	// xor_data: set Start-Code

    if (bde1Length > 0) {
        length += 1 + bde1Length;															// LC=LC+LBDE1+(BDE1-length)
        if (bde1Typ == 1) {																	// ASCII values
            lbdex = getLbdex(1, bde1Length);
        } else {																			// Non ASCII values
            lbdex = getLbdex(0, bde1Length);
        }
        lbdexLeftHalfbyte = getHalfByteDezValue(lbdex.substr(0, 4));
        lbdexRightHalfbyte = getHalfByteDezValue(lbdex.substr(4, 8));
        xorData += sprintf("%X%X", lbdexLeftHalfbyte, lbdexRightHalfbyte) + bde1Code;		// xor_data: LS; Start-Code; set LBDE1; set BDE1
    }

    if (bde2Length > 0) {
        length += 1 + bde2Length;															// LC=LC+LBDE2+BDE2-length)
        if (bde2Typ == 1) {																	// ASCII values
            lbdex = getLbdex(1, bde2Length);
        } else {																			// Non ASCII values
            lbdex = getLbdex(0, bde2Length);
        }
        lbdexLeftHalfbyte = getHalfByteDezValue(lbdex.substr(0, 4));
        lbdexRightHalfbyte = getHalfByteDezValue(lbdex.substr(4, 8));
        xorData += sprintf("%X%X", lbdexLeftHalfbyte, lbdexRightHalfbyte) + bde2Code;		// xor_data: LS; Start-Code; LBDE1; BDE1; set LBDE2; set BDE2
    }

    if (bde3Length > 0) {
        length += 1 + bde3Length;
        if (bde3Typ == 1) {																	// ASCII values
            lbdex = getLbdex(1, bde3Length);
        } else {																			// Non ASCII values
            lbdex = getLbdex(0, bde3Length);
        }
        lbdexLeftHalfbyte = getHalfByteDezValue(lbdex.substr(0, 4));
        lbdexRightHalfbyte = getHalfByteDezValue(lbdex.substr(4, 8));
        xorData += sprintf("%X%X", lbdexLeftHalfbyte, lbdexRightHalfbyte) + bde3Code;		// xor_data: LS; Start-Code; LBDE1; BDE1; LBDE2; BDE2; set LBDE3; set BDE3
    }
    xorData = sprintf("%02X%s", length, xorData);											// xor_data: set LC; LS; Start-Code; LBDE1; BDE1; LBDE2; BDE2; LBDE3; BDE3
    return xorData;
}

//
// luhnCalc.js
//

function luhnCalc(number) {
    // Set the string length and parity
    var numberLength = number.length;
    var parity = numberLength % 2;
    // Loop through each digit and do the maths
    var total = 0;

    for (var i = 0; i < numberLength; i++) {
        var digit = number.charCodeAt(i);

        if (digit > 0x39) { // > '9'
            digit -= (0x41 - 10); //  - 'A' + 10
        } else {
            digit -= 0x30;	// '0'
        }
        // Multiply alternate digits by two
        if (i % 2 != parity) {
            digit = digit * 2;
            digit = Math.floor(digit / 10) + (digit % 10);
        }

        // SecOPTIC character
        if ((i % 2 == parity) && (digit > 9)) {
            digit = Math.floor(digit / 10) + (digit % 10);
        }

        // Total up the digits
        total = total + digit;
    }
    // If the total mod 10 equals 0, the number is valid
    return ((10 - (total % 10)) % 10);
}

//
// sprintf.js
//

function str_repeat(i, m) {
    for (var o = []; m > 0; o[--m] = i);
    return (o.join(''));
}

function sprintf() {
    var i = 0, a, f = arguments[i++], o = [], m, p, c, x;
    while (f) {
        if (m = /^[^\x25]+/.exec(f)) {
            o.push(m[0]);
        } else if (m = /^\x25{2}/.exec(f)) {
            o.push('%');
        } else if (m = /^\x25(?:(\d+)\$)?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(f)) {
            if (((a = arguments[m[1] || i++]) == null) || (a == undefined)) {
                throw ("Too few arguments.");
            }
            if (/[^s]/.test(m[7]) && (typeof (a) != 'number')) {
                throw ("Expecting number but found " + typeof (a));
            }
            switch (m[7]) {
                case 'b':
                    a = a.toString(2);
                    break;
                case 'c':
                    a = String.fromCharCode(a);
                    break;
                case 'd':
                    a = parseInt(a);
                    break;
                case 'e':
                    a = m[6] ? a.toExponential(m[6]) : a.toExponential();
                    break;
                case 'f':
                    a = m[6] ? parseFloat(a).toFixed(m[6]) : parseFloat(a);
                    break;
                case 'o':
                    a = a.toString(8);
                    break;
                case 's':
                    a = ((a = String(a)) && m[6] ? a.substring(0, m[6]) : a);
                    break;
                case 'u':
                    a = Math.abs(a);
                    break;
                case 'x':
                    a = a.toString(16);
                    break;
                case 'X':
                    a = a.toString(16).toUpperCase();
                    break;
            }
            a = (/[def]/.test(m[7]) && m[2] && a > 0 ? '+' + a : a);
            c = m[3] ? m[3] == '0' ? '0' : m[3].charAt(1) : ' ';
            x = m[5] - String(a).length;
            p = m[5] ? str_repeat(c, x) : '';
            o.push(m[4] ? a + p : p + a);
        }
        else {
            throw ("Error!");
        }
        f = f.substring(m[0].length);
    }
    return o.join('');
}

//
// xorCalc.js
//

function xorCalc(number) {
    var numberLength = number.length;
    // Loop through each digit and do the maths
    var total = 0;
    for (var i = 0; i < numberLength; i++) {
        var digit = number.charCodeAt(i);
        if (digit > 0x39) { // > '9'
            digit -= (0x41 - 10); //  - 'A' + 10
        } else {
            digit -= 0x30;	// '0'
        }
        // Total up the digits
        total ^= digit;
    }
    return (total);
}




// WEBPACK FOOTER //
// ./src/components/signing/views/flickerLib.js